function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h12v12H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.662 1.37h.012a.502.502 0 01.08.014l.022.006a.446.446 0 01.165.086.504.504 0 01.044.04l.021.022c.01.01.019.022.027.033l-.048-.056a.502.502 0 01.147.36l-.001.021a.503.503 0 01-.004.036l-.004.026-.827 4.566a.5.5 0 01-.992-.089l.008-.09.541-2.991-8 8a.5.5 0 01-.764-.638l.057-.07L9.223 2.57l-3.088.43a.5.5 0 01-.544-.34l-.02-.087a.5.5 0 01.338-.544l.088-.02 4.566-.635.012-.001a.503.503 0 01.055-.003l-.067.004a.507.507 0 01.099-.004z",
  fill: "#39C696"
}))));